export default {"src":"/_next/static/media/cc.790efefb.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};